// src/App.js
import React, { useState } from "react";
import Sidebar from "./components/Sidebar";
import FileUpload from "./components/FileUpload";
import FileList from "./components/FileList";
import JSONGenerator from "./components/JSONGenerator";
import PackImporter from "./components/PackImporter";
import "./App.css";

function App() {
  const [files, setFiles] = useState([]);

  // Handle new file upload
  const handleFileUpload = (event) => {
    const uploadedFiles = Array.from(event.target.files).map((file) => ({
      file,
      char: "", // default character for new uploads
      xOffset: 8,
      yOffset: 42,
    }));
    setFiles((prev) => [...prev, ...uploadedFiles]);
  };

  // Handle updating character for a specific file
  const handleCharChange = (index, value) => {
    if (value.length > 1) return; // limit to one character
    const updatedFiles = [...files];
    updatedFiles[index].char = value;
    setFiles(updatedFiles);
  };

  // Merge imported GUIs with existing ones
  const handleImportFiles = (importedFiles) => {
    setFiles((prev) => [...prev, ...importedFiles]);
  };

  // Callback from FileList when a file is updated (e.g., after processing)
  const onUpdateFiles = (updatedFiles) => {
    setFiles(updatedFiles);
  };

  return (
    <div className="app">
      <Sidebar />
      <header className="app-header">
        <br/>
        Abishek's GUI Converter
      </header>
      <div className="content">
        <div className="converter-section">
          {/* Import an existing pack */}
          <PackImporter onImportFiles={handleImportFiles} />
          {/* Upload new PNG files */}
          <FileUpload onFileUpload={handleFileUpload} />
          <FileList
            files={files}
            onCharChange={handleCharChange}
            onUpdateFiles={onUpdateFiles}
          />
          {files.length > 0 && <JSONGenerator files={files} />}
        </div>
        <div className="discord-card">
          <h2>Join Our Support Server</h2>
          <iframe
            src="https://discord.com/widget?id=1163933899236331632&theme=dark"
            width="100%"
            height="400"
            allowTransparency="true"
            frameBorder="0"
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
            title="Discord Widget"
          ></iframe>
        </div>
      </div>
      <div className="info-card-wrapper">
        <div className="info-card">
          <h2>Instructions</h2>
          <p>
            Upload the custom GUI texture PNGs (or import an existing pack), then enter the
            corresponding character for each GUI. The character is typically defined in
            configuration files for ItemsAdder, Oraxen, or Nexo.
          </p>
          <p>
            The GUI PNG will be automatically aligned. If adjustments are needed, tweak the
            offsets and preview before generating the final pack.
          </p>
        </div>
      </div>
      <footer className="app-footer">
        <p>
          &copy; 2025{" "}
          <a
            href="https://abishekbhusal.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Abishek Bhusal
          </a>
          . All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default App;
